// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/request_schema/v1/request_schema.proto" (package "c1.api.request_schema.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { Field } from "../../form/v1/form";
import { Struct } from "../../../../google/protobuf/struct";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Form } from "../../form/v1/form";
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchema
 */
export interface RequestSchema {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.form.v1.Form form = 8
     */
    form?: Form;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp modified_at = 7
     */
    modifiedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.request_schema.v1.JustificationVisibility justification_visibility = 9
     */
    justificationVisibility: JustificationVisibility;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaRef
 */
export interface RequestSchemaRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @deprecated
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaInstance
 */
export interface RequestSchemaInstance {
    /**
     * @generated from protobuf field: c1.api.request_schema.v1.RequestSchema request_schema = 1
     */
    requestSchema?: RequestSchema;
    /**
     * @generated from protobuf field: google.protobuf.Struct data = 2
     */
    data?: Struct;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaEntitlementBinding
 */
export interface RequestSchemaEntitlementBinding {
    /**
     * @generated from protobuf field: string request_schema_id = 1
     */
    requestSchemaId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string entitlement_id = 3
     */
    entitlementId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaWithBinding
 */
export interface RequestSchemaWithBinding {
    /**
     * @generated from protobuf field: c1.api.request_schema.v1.RequestSchema request_schema = 1
     */
    requestSchema?: RequestSchema;
    /**
     * @generated from protobuf field: c1.api.request_schema.v1.RequestSchemaEntitlementBinding binding = 2
     */
    binding?: RequestSchemaEntitlementBinding;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateRequest
 */
export interface RequestSchemaServiceCreateRequest {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * @generated from protobuf field: repeated c1.api.form.v1.Field fields = 3
     */
    fields: Field[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateResponse
 */
export interface RequestSchemaServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.request_schema.v1.RequestSchema request_schema = 1
     */
    requestSchema?: RequestSchema;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceDeleteRequest
 */
export interface RequestSchemaServiceDeleteRequest {
    /**
     * @generated from protobuf field: string request_schema_id = 1
     */
    requestSchemaId: string;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceDeleteResponse
 */
export interface RequestSchemaServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceGetRequest
 */
export interface RequestSchemaServiceGetRequest {
    /**
     * @generated from protobuf field: string request_schema_id = 1
     */
    requestSchemaId: string;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceGetResponse
 */
export interface RequestSchemaServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.request_schema.v1.RequestSchema request_schema = 1
     */
    requestSchema?: RequestSchema;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindByAppEntitlementRequest
 */
export interface RequestSchemaServiceFindByAppEntitlementRequest {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementRef entitlement_ref = 1
     */
    entitlementRef?: AppEntitlementRef;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindByAppEntitlementResponse
 */
export interface RequestSchemaServiceFindByAppEntitlementResponse {
    /**
     * @generated from protobuf field: c1.api.request_schema.v1.RequestSchema request_schema = 1
     */
    requestSchema?: RequestSchema;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceListRequest
 */
export interface RequestSchemaServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.request_schema.v1.RequestSchemaRef refs = 3
     */
    refs: RequestSchemaRef[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceListResponse
 */
export interface RequestSchemaServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.request_schema.v1.RequestSchema list = 1
     */
    list: RequestSchema[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceUpdateRequest
 */
export interface RequestSchemaServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.request_schema.v1.RequestSchema request_schema = 1
     */
    requestSchema?: RequestSchema;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceUpdateResponse
 */
export interface RequestSchemaServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.request_schema.v1.RequestSchema request_schema = 1
     */
    requestSchema?: RequestSchema;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingsRequest
 */
export interface RequestSchemaServiceCreateEntitlementBindingsRequest {
    /**
     * @generated from protobuf field: string request_schema_id = 1
     */
    requestSchemaId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 2
     */
    entitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingsResponse
 */
export interface RequestSchemaServiceCreateEntitlementBindingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.request_schema.v1.RequestSchemaEntitlementBinding entitlement_bindings = 1
     */
    entitlementBindings: RequestSchemaEntitlementBinding[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingsRequest
 */
export interface RequestSchemaServiceRemoveEntitlementBindingsRequest {
    /**
     * @generated from protobuf field: string request_schema_id = 1
     */
    requestSchemaId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 2
     */
    entitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingsResponse
 */
export interface RequestSchemaServiceRemoveEntitlementBindingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.request_schema.v1.RequestSchemaEntitlementBinding entitlement_bindings = 1
     */
    entitlementBindings: RequestSchemaEntitlementBinding[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingRequest
 */
export interface RequestSchemaServiceCreateEntitlementBindingRequest {
    /**
     * @generated from protobuf field: string request_schema_id = 1
     */
    requestSchemaId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementRef entitlement_ref = 2
     */
    entitlementRef?: AppEntitlementRef;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingResponse
 */
export interface RequestSchemaServiceCreateEntitlementBindingResponse {
    /**
     * @generated from protobuf field: string request_schema_id = 1
     */
    requestSchemaId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementRef entitlement_ref = 2
     */
    entitlementRef?: AppEntitlementRef;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingRequest
 */
export interface RequestSchemaServiceRemoveEntitlementBindingRequest {
    /**
     * @generated from protobuf field: string request_schema_id = 1
     */
    requestSchemaId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementRef entitlement_ref = 2
     */
    entitlementRef?: AppEntitlementRef;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingResponse
 */
export interface RequestSchemaServiceRemoveEntitlementBindingResponse {
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindBindingForAppEntitlementRequest
 */
export interface RequestSchemaServiceFindBindingForAppEntitlementRequest {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementRef entitlement_ref = 1
     */
    entitlementRef?: AppEntitlementRef;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindBindingForAppEntitlementResponse
 */
export interface RequestSchemaServiceFindBindingForAppEntitlementResponse {
    /**
     * @generated from protobuf field: string request_schema_id = 1
     */
    requestSchemaId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementRef entitlement_ref = 2
     */
    entitlementRef?: AppEntitlementRef;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceUpdateBindingsRequest
 */
export interface RequestSchemaServiceUpdateBindingsRequest {
    /**
     * @generated from protobuf field: string request_schema_id = 1
     */
    requestSchemaId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 2
     */
    entitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceUpdateBindingsResponse
 */
export interface RequestSchemaServiceUpdateBindingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.request_schema.v1.RequestSchemaEntitlementBinding request_schema_entitlement_bindings = 1
     */
    requestSchemaEntitlementBindings: RequestSchemaEntitlementBinding[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindForAppEntitlementsRequest
 */
export interface RequestSchemaServiceFindForAppEntitlementsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 1
     */
    entitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindForAppEntitlementsResponse
 */
export interface RequestSchemaServiceFindForAppEntitlementsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.request_schema.v1.RequestSchemaWithBinding request_schemas_entitlement_with_bindings = 1
     */
    requestSchemasEntitlementWithBindings: RequestSchemaWithBinding[];
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceCountBindingsForSchemaRequest
 */
export interface RequestSchemaServiceCountBindingsForSchemaRequest {
    /**
     * @generated from protobuf field: string request_schema_id = 1
     */
    requestSchemaId: string;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceCountBindingsForSchemaResponse
 */
export interface RequestSchemaServiceCountBindingsForSchemaResponse {
    /**
     * @generated from protobuf field: int64 num_bindings = 1
     */
    numBindings: number;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceSearchRequest
 */
export interface RequestSchemaServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.request_schema.v1.RequestSchemaServiceSearchResponse
 */
export interface RequestSchemaServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.request_schema.v1.RequestSchema list = 1
     */
    list: RequestSchema[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf enum c1.api.request_schema.v1.JustificationVisibility
 */
export enum JustificationVisibility {
    /**
     * @generated from protobuf enum value: JUSTIFICATION_VISIBILITY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: JUSTIFICATION_VISIBILITY_SHOW = 1;
     */
    SHOW = 1,
    /**
     * @generated from protobuf enum value: JUSTIFICATION_VISIBILITY_HIDE = 2;
     */
    HIDE = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchema$Type extends MessageType<RequestSchema> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchema", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "form", kind: "message", T: () => Form },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "modified_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "justification_visibility", kind: "enum", T: () => ["c1.api.request_schema.v1.JustificationVisibility", JustificationVisibility, "JUSTIFICATION_VISIBILITY_"] }
        ]);
    }
    create(value?: PartialMessage<RequestSchema>): RequestSchema {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.justificationVisibility = 0;
        if (value !== undefined)
            reflectionMergePartial<RequestSchema>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchema): RequestSchema {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* c1.api.form.v1.Form form */ 8:
                    message.form = Form.internalBinaryRead(reader, reader.uint32(), options, message.form);
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 6:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* google.protobuf.Timestamp modified_at */ 7:
                    message.modifiedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.modifiedAt);
                    break;
                case /* c1.api.request_schema.v1.JustificationVisibility justification_visibility */ 9:
                    message.justificationVisibility = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchema, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 6; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp modified_at = 7; */
        if (message.modifiedAt)
            Timestamp.internalBinaryWrite(message.modifiedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.Form form = 8; */
        if (message.form)
            Form.internalBinaryWrite(message.form, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.request_schema.v1.JustificationVisibility justification_visibility = 9; */
        if (message.justificationVisibility !== 0)
            writer.tag(9, WireType.Varint).int32(message.justificationVisibility);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchema
 */
export const RequestSchema = new RequestSchema$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaRef$Type extends MessageType<RequestSchemaRef> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaRef>): RequestSchemaRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaRef): RequestSchemaRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaRef
 */
export const RequestSchemaRef = new RequestSchemaRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaInstance$Type extends MessageType<RequestSchemaInstance> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaInstance", [
            { no: 1, name: "request_schema", kind: "message", T: () => RequestSchema },
            { no: 2, name: "data", kind: "message", T: () => Struct }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaInstance>): RequestSchemaInstance {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaInstance>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaInstance): RequestSchemaInstance {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.request_schema.v1.RequestSchema request_schema */ 1:
                    message.requestSchema = RequestSchema.internalBinaryRead(reader, reader.uint32(), options, message.requestSchema);
                    break;
                case /* google.protobuf.Struct data */ 2:
                    message.data = Struct.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaInstance, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.request_schema.v1.RequestSchema request_schema = 1; */
        if (message.requestSchema)
            RequestSchema.internalBinaryWrite(message.requestSchema, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Struct data = 2; */
        if (message.data)
            Struct.internalBinaryWrite(message.data, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaInstance
 */
export const RequestSchemaInstance = new RequestSchemaInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaEntitlementBinding$Type extends MessageType<RequestSchemaEntitlementBinding> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaEntitlementBinding", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaEntitlementBinding>): RequestSchemaEntitlementBinding {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestSchemaId = "";
        message.appId = "";
        message.entitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaEntitlementBinding>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaEntitlementBinding): RequestSchemaEntitlementBinding {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_schema_id */ 1:
                    message.requestSchemaId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string entitlement_id */ 3:
                    message.entitlementId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 5:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 6:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaEntitlementBinding, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_schema_id = 1; */
        if (message.requestSchemaId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestSchemaId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string entitlement_id = 3; */
        if (message.entitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.entitlementId);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 5; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 6; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaEntitlementBinding
 */
export const RequestSchemaEntitlementBinding = new RequestSchemaEntitlementBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaWithBinding$Type extends MessageType<RequestSchemaWithBinding> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaWithBinding", [
            { no: 1, name: "request_schema", kind: "message", T: () => RequestSchema },
            { no: 2, name: "binding", kind: "message", T: () => RequestSchemaEntitlementBinding }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaWithBinding>): RequestSchemaWithBinding {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaWithBinding>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaWithBinding): RequestSchemaWithBinding {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.request_schema.v1.RequestSchema request_schema */ 1:
                    message.requestSchema = RequestSchema.internalBinaryRead(reader, reader.uint32(), options, message.requestSchema);
                    break;
                case /* c1.api.request_schema.v1.RequestSchemaEntitlementBinding binding */ 2:
                    message.binding = RequestSchemaEntitlementBinding.internalBinaryRead(reader, reader.uint32(), options, message.binding);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaWithBinding, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.request_schema.v1.RequestSchema request_schema = 1; */
        if (message.requestSchema)
            RequestSchema.internalBinaryWrite(message.requestSchema, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.request_schema.v1.RequestSchemaEntitlementBinding binding = 2; */
        if (message.binding)
            RequestSchemaEntitlementBinding.internalBinaryWrite(message.binding, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaWithBinding
 */
export const RequestSchemaWithBinding = new RequestSchemaWithBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceCreateRequest$Type extends MessageType<RequestSchemaServiceCreateRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceCreateRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "255" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Field, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "50" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceCreateRequest>): RequestSchemaServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.description = "";
        message.fields = [];
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceCreateRequest): RequestSchemaServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* repeated c1.api.form.v1.Field fields */ 3:
                    message.fields.push(Field.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* repeated c1.api.form.v1.Field fields = 3; */
        for (let i = 0; i < message.fields.length; i++)
            Field.internalBinaryWrite(message.fields[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateRequest
 */
export const RequestSchemaServiceCreateRequest = new RequestSchemaServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceCreateResponse$Type extends MessageType<RequestSchemaServiceCreateResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceCreateResponse", [
            { no: 1, name: "request_schema", kind: "message", T: () => RequestSchema }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceCreateResponse>): RequestSchemaServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceCreateResponse): RequestSchemaServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.request_schema.v1.RequestSchema request_schema */ 1:
                    message.requestSchema = RequestSchema.internalBinaryRead(reader, reader.uint32(), options, message.requestSchema);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.request_schema.v1.RequestSchema request_schema = 1; */
        if (message.requestSchema)
            RequestSchema.internalBinaryWrite(message.requestSchema, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateResponse
 */
export const RequestSchemaServiceCreateResponse = new RequestSchemaServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceDeleteRequest$Type extends MessageType<RequestSchemaServiceDeleteRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceDeleteRequest", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceDeleteRequest>): RequestSchemaServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestSchemaId = "";
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceDeleteRequest): RequestSchemaServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_schema_id */ 1:
                    message.requestSchemaId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_schema_id = 1; */
        if (message.requestSchemaId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestSchemaId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceDeleteRequest
 */
export const RequestSchemaServiceDeleteRequest = new RequestSchemaServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceDeleteResponse$Type extends MessageType<RequestSchemaServiceDeleteResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<RequestSchemaServiceDeleteResponse>): RequestSchemaServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceDeleteResponse): RequestSchemaServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceDeleteResponse
 */
export const RequestSchemaServiceDeleteResponse = new RequestSchemaServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceGetRequest$Type extends MessageType<RequestSchemaServiceGetRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceGetRequest", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceGetRequest>): RequestSchemaServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestSchemaId = "";
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceGetRequest): RequestSchemaServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_schema_id */ 1:
                    message.requestSchemaId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_schema_id = 1; */
        if (message.requestSchemaId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestSchemaId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceGetRequest
 */
export const RequestSchemaServiceGetRequest = new RequestSchemaServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceGetResponse$Type extends MessageType<RequestSchemaServiceGetResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceGetResponse", [
            { no: 1, name: "request_schema", kind: "message", T: () => RequestSchema }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceGetResponse>): RequestSchemaServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceGetResponse): RequestSchemaServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.request_schema.v1.RequestSchema request_schema */ 1:
                    message.requestSchema = RequestSchema.internalBinaryRead(reader, reader.uint32(), options, message.requestSchema);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.request_schema.v1.RequestSchema request_schema = 1; */
        if (message.requestSchema)
            RequestSchema.internalBinaryWrite(message.requestSchema, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceGetResponse
 */
export const RequestSchemaServiceGetResponse = new RequestSchemaServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceFindByAppEntitlementRequest$Type extends MessageType<RequestSchemaServiceFindByAppEntitlementRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceFindByAppEntitlementRequest", [
            { no: 1, name: "entitlement_ref", kind: "message", T: () => AppEntitlementRef }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceFindByAppEntitlementRequest>): RequestSchemaServiceFindByAppEntitlementRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceFindByAppEntitlementRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceFindByAppEntitlementRequest): RequestSchemaServiceFindByAppEntitlementRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementRef entitlement_ref */ 1:
                    message.entitlementRef = AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options, message.entitlementRef);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceFindByAppEntitlementRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementRef entitlement_ref = 1; */
        if (message.entitlementRef)
            AppEntitlementRef.internalBinaryWrite(message.entitlementRef, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindByAppEntitlementRequest
 */
export const RequestSchemaServiceFindByAppEntitlementRequest = new RequestSchemaServiceFindByAppEntitlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceFindByAppEntitlementResponse$Type extends MessageType<RequestSchemaServiceFindByAppEntitlementResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceFindByAppEntitlementResponse", [
            { no: 1, name: "request_schema", kind: "message", T: () => RequestSchema }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceFindByAppEntitlementResponse>): RequestSchemaServiceFindByAppEntitlementResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceFindByAppEntitlementResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceFindByAppEntitlementResponse): RequestSchemaServiceFindByAppEntitlementResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.request_schema.v1.RequestSchema request_schema */ 1:
                    message.requestSchema = RequestSchema.internalBinaryRead(reader, reader.uint32(), options, message.requestSchema);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceFindByAppEntitlementResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.request_schema.v1.RequestSchema request_schema = 1; */
        if (message.requestSchema)
            RequestSchema.internalBinaryWrite(message.requestSchema, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindByAppEntitlementResponse
 */
export const RequestSchemaServiceFindByAppEntitlementResponse = new RequestSchemaServiceFindByAppEntitlementResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceListRequest$Type extends MessageType<RequestSchemaServiceListRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestSchemaRef }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceListRequest>): RequestSchemaServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceListRequest): RequestSchemaServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.request_schema.v1.RequestSchemaRef refs */ 3:
                    message.refs.push(RequestSchemaRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.request_schema.v1.RequestSchemaRef refs = 3; */
        for (let i = 0; i < message.refs.length; i++)
            RequestSchemaRef.internalBinaryWrite(message.refs[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceListRequest
 */
export const RequestSchemaServiceListRequest = new RequestSchemaServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceListResponse$Type extends MessageType<RequestSchemaServiceListResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestSchema },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceListResponse>): RequestSchemaServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceListResponse): RequestSchemaServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.request_schema.v1.RequestSchema list */ 1:
                    message.list.push(RequestSchema.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.request_schema.v1.RequestSchema list = 1; */
        for (let i = 0; i < message.list.length; i++)
            RequestSchema.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceListResponse
 */
export const RequestSchemaServiceListResponse = new RequestSchemaServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceUpdateRequest$Type extends MessageType<RequestSchemaServiceUpdateRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceUpdateRequest", [
            { no: 1, name: "request_schema", kind: "message", T: () => RequestSchema, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceUpdateRequest>): RequestSchemaServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceUpdateRequest): RequestSchemaServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.request_schema.v1.RequestSchema request_schema */ 1:
                    message.requestSchema = RequestSchema.internalBinaryRead(reader, reader.uint32(), options, message.requestSchema);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.request_schema.v1.RequestSchema request_schema = 1; */
        if (message.requestSchema)
            RequestSchema.internalBinaryWrite(message.requestSchema, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceUpdateRequest
 */
export const RequestSchemaServiceUpdateRequest = new RequestSchemaServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceUpdateResponse$Type extends MessageType<RequestSchemaServiceUpdateResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceUpdateResponse", [
            { no: 1, name: "request_schema", kind: "message", T: () => RequestSchema }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceUpdateResponse>): RequestSchemaServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceUpdateResponse): RequestSchemaServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.request_schema.v1.RequestSchema request_schema */ 1:
                    message.requestSchema = RequestSchema.internalBinaryRead(reader, reader.uint32(), options, message.requestSchema);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.request_schema.v1.RequestSchema request_schema = 1; */
        if (message.requestSchema)
            RequestSchema.internalBinaryWrite(message.requestSchema, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceUpdateResponse
 */
export const RequestSchemaServiceUpdateResponse = new RequestSchemaServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceCreateEntitlementBindingsRequest$Type extends MessageType<RequestSchemaServiceCreateEntitlementBindingsRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingsRequest", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "25" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceCreateEntitlementBindingsRequest>): RequestSchemaServiceCreateEntitlementBindingsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestSchemaId = "";
        message.entitlementRefs = [];
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceCreateEntitlementBindingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceCreateEntitlementBindingsRequest): RequestSchemaServiceCreateEntitlementBindingsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_schema_id */ 1:
                    message.requestSchemaId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef entitlement_refs */ 2:
                    message.entitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceCreateEntitlementBindingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_schema_id = 1; */
        if (message.requestSchemaId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestSchemaId);
        /* repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 2; */
        for (let i = 0; i < message.entitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.entitlementRefs[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingsRequest
 */
export const RequestSchemaServiceCreateEntitlementBindingsRequest = new RequestSchemaServiceCreateEntitlementBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceCreateEntitlementBindingsResponse$Type extends MessageType<RequestSchemaServiceCreateEntitlementBindingsResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingsResponse", [
            { no: 1, name: "entitlement_bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestSchemaEntitlementBinding }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceCreateEntitlementBindingsResponse>): RequestSchemaServiceCreateEntitlementBindingsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entitlementBindings = [];
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceCreateEntitlementBindingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceCreateEntitlementBindingsResponse): RequestSchemaServiceCreateEntitlementBindingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.request_schema.v1.RequestSchemaEntitlementBinding entitlement_bindings */ 1:
                    message.entitlementBindings.push(RequestSchemaEntitlementBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceCreateEntitlementBindingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.request_schema.v1.RequestSchemaEntitlementBinding entitlement_bindings = 1; */
        for (let i = 0; i < message.entitlementBindings.length; i++)
            RequestSchemaEntitlementBinding.internalBinaryWrite(message.entitlementBindings[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingsResponse
 */
export const RequestSchemaServiceCreateEntitlementBindingsResponse = new RequestSchemaServiceCreateEntitlementBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceRemoveEntitlementBindingsRequest$Type extends MessageType<RequestSchemaServiceRemoveEntitlementBindingsRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingsRequest", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "25" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceRemoveEntitlementBindingsRequest>): RequestSchemaServiceRemoveEntitlementBindingsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestSchemaId = "";
        message.entitlementRefs = [];
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceRemoveEntitlementBindingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceRemoveEntitlementBindingsRequest): RequestSchemaServiceRemoveEntitlementBindingsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_schema_id */ 1:
                    message.requestSchemaId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef entitlement_refs */ 2:
                    message.entitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceRemoveEntitlementBindingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_schema_id = 1; */
        if (message.requestSchemaId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestSchemaId);
        /* repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 2; */
        for (let i = 0; i < message.entitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.entitlementRefs[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingsRequest
 */
export const RequestSchemaServiceRemoveEntitlementBindingsRequest = new RequestSchemaServiceRemoveEntitlementBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceRemoveEntitlementBindingsResponse$Type extends MessageType<RequestSchemaServiceRemoveEntitlementBindingsResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingsResponse", [
            { no: 1, name: "entitlement_bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestSchemaEntitlementBinding, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "25" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceRemoveEntitlementBindingsResponse>): RequestSchemaServiceRemoveEntitlementBindingsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entitlementBindings = [];
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceRemoveEntitlementBindingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceRemoveEntitlementBindingsResponse): RequestSchemaServiceRemoveEntitlementBindingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.request_schema.v1.RequestSchemaEntitlementBinding entitlement_bindings */ 1:
                    message.entitlementBindings.push(RequestSchemaEntitlementBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceRemoveEntitlementBindingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.request_schema.v1.RequestSchemaEntitlementBinding entitlement_bindings = 1; */
        for (let i = 0; i < message.entitlementBindings.length; i++)
            RequestSchemaEntitlementBinding.internalBinaryWrite(message.entitlementBindings[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingsResponse
 */
export const RequestSchemaServiceRemoveEntitlementBindingsResponse = new RequestSchemaServiceRemoveEntitlementBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceCreateEntitlementBindingRequest$Type extends MessageType<RequestSchemaServiceCreateEntitlementBindingRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingRequest", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_ref", kind: "message", T: () => AppEntitlementRef }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceCreateEntitlementBindingRequest>): RequestSchemaServiceCreateEntitlementBindingRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestSchemaId = "";
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceCreateEntitlementBindingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceCreateEntitlementBindingRequest): RequestSchemaServiceCreateEntitlementBindingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_schema_id */ 1:
                    message.requestSchemaId = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementRef entitlement_ref */ 2:
                    message.entitlementRef = AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options, message.entitlementRef);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceCreateEntitlementBindingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_schema_id = 1; */
        if (message.requestSchemaId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestSchemaId);
        /* c1.api.app.v1.AppEntitlementRef entitlement_ref = 2; */
        if (message.entitlementRef)
            AppEntitlementRef.internalBinaryWrite(message.entitlementRef, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingRequest
 */
export const RequestSchemaServiceCreateEntitlementBindingRequest = new RequestSchemaServiceCreateEntitlementBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceCreateEntitlementBindingResponse$Type extends MessageType<RequestSchemaServiceCreateEntitlementBindingResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingResponse", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "entitlement_ref", kind: "message", T: () => AppEntitlementRef }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceCreateEntitlementBindingResponse>): RequestSchemaServiceCreateEntitlementBindingResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestSchemaId = "";
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceCreateEntitlementBindingResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceCreateEntitlementBindingResponse): RequestSchemaServiceCreateEntitlementBindingResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_schema_id */ 1:
                    message.requestSchemaId = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementRef entitlement_ref */ 2:
                    message.entitlementRef = AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options, message.entitlementRef);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceCreateEntitlementBindingResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_schema_id = 1; */
        if (message.requestSchemaId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestSchemaId);
        /* c1.api.app.v1.AppEntitlementRef entitlement_ref = 2; */
        if (message.entitlementRef)
            AppEntitlementRef.internalBinaryWrite(message.entitlementRef, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceCreateEntitlementBindingResponse
 */
export const RequestSchemaServiceCreateEntitlementBindingResponse = new RequestSchemaServiceCreateEntitlementBindingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceRemoveEntitlementBindingRequest$Type extends MessageType<RequestSchemaServiceRemoveEntitlementBindingRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingRequest", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_ref", kind: "message", T: () => AppEntitlementRef }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceRemoveEntitlementBindingRequest>): RequestSchemaServiceRemoveEntitlementBindingRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestSchemaId = "";
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceRemoveEntitlementBindingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceRemoveEntitlementBindingRequest): RequestSchemaServiceRemoveEntitlementBindingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_schema_id */ 1:
                    message.requestSchemaId = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementRef entitlement_ref */ 2:
                    message.entitlementRef = AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options, message.entitlementRef);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceRemoveEntitlementBindingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_schema_id = 1; */
        if (message.requestSchemaId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestSchemaId);
        /* c1.api.app.v1.AppEntitlementRef entitlement_ref = 2; */
        if (message.entitlementRef)
            AppEntitlementRef.internalBinaryWrite(message.entitlementRef, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingRequest
 */
export const RequestSchemaServiceRemoveEntitlementBindingRequest = new RequestSchemaServiceRemoveEntitlementBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceRemoveEntitlementBindingResponse$Type extends MessageType<RequestSchemaServiceRemoveEntitlementBindingResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingResponse", []);
    }
    create(value?: PartialMessage<RequestSchemaServiceRemoveEntitlementBindingResponse>): RequestSchemaServiceRemoveEntitlementBindingResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceRemoveEntitlementBindingResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceRemoveEntitlementBindingResponse): RequestSchemaServiceRemoveEntitlementBindingResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceRemoveEntitlementBindingResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceRemoveEntitlementBindingResponse
 */
export const RequestSchemaServiceRemoveEntitlementBindingResponse = new RequestSchemaServiceRemoveEntitlementBindingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceFindBindingForAppEntitlementRequest$Type extends MessageType<RequestSchemaServiceFindBindingForAppEntitlementRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceFindBindingForAppEntitlementRequest", [
            { no: 1, name: "entitlement_ref", kind: "message", T: () => AppEntitlementRef }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceFindBindingForAppEntitlementRequest>): RequestSchemaServiceFindBindingForAppEntitlementRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceFindBindingForAppEntitlementRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceFindBindingForAppEntitlementRequest): RequestSchemaServiceFindBindingForAppEntitlementRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementRef entitlement_ref */ 1:
                    message.entitlementRef = AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options, message.entitlementRef);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceFindBindingForAppEntitlementRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementRef entitlement_ref = 1; */
        if (message.entitlementRef)
            AppEntitlementRef.internalBinaryWrite(message.entitlementRef, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindBindingForAppEntitlementRequest
 */
export const RequestSchemaServiceFindBindingForAppEntitlementRequest = new RequestSchemaServiceFindBindingForAppEntitlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceFindBindingForAppEntitlementResponse$Type extends MessageType<RequestSchemaServiceFindBindingForAppEntitlementResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceFindBindingForAppEntitlementResponse", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "entitlement_ref", kind: "message", T: () => AppEntitlementRef }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceFindBindingForAppEntitlementResponse>): RequestSchemaServiceFindBindingForAppEntitlementResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestSchemaId = "";
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceFindBindingForAppEntitlementResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceFindBindingForAppEntitlementResponse): RequestSchemaServiceFindBindingForAppEntitlementResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_schema_id */ 1:
                    message.requestSchemaId = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementRef entitlement_ref */ 2:
                    message.entitlementRef = AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options, message.entitlementRef);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceFindBindingForAppEntitlementResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_schema_id = 1; */
        if (message.requestSchemaId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestSchemaId);
        /* c1.api.app.v1.AppEntitlementRef entitlement_ref = 2; */
        if (message.entitlementRef)
            AppEntitlementRef.internalBinaryWrite(message.entitlementRef, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindBindingForAppEntitlementResponse
 */
export const RequestSchemaServiceFindBindingForAppEntitlementResponse = new RequestSchemaServiceFindBindingForAppEntitlementResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceUpdateBindingsRequest$Type extends MessageType<RequestSchemaServiceUpdateBindingsRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceUpdateBindingsRequest", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "25" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceUpdateBindingsRequest>): RequestSchemaServiceUpdateBindingsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestSchemaId = "";
        message.entitlementRefs = [];
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceUpdateBindingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceUpdateBindingsRequest): RequestSchemaServiceUpdateBindingsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_schema_id */ 1:
                    message.requestSchemaId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef entitlement_refs */ 2:
                    message.entitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceUpdateBindingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_schema_id = 1; */
        if (message.requestSchemaId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestSchemaId);
        /* repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 2; */
        for (let i = 0; i < message.entitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.entitlementRefs[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceUpdateBindingsRequest
 */
export const RequestSchemaServiceUpdateBindingsRequest = new RequestSchemaServiceUpdateBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceUpdateBindingsResponse$Type extends MessageType<RequestSchemaServiceUpdateBindingsResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceUpdateBindingsResponse", [
            { no: 1, name: "request_schema_entitlement_bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestSchemaEntitlementBinding }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceUpdateBindingsResponse>): RequestSchemaServiceUpdateBindingsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestSchemaEntitlementBindings = [];
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceUpdateBindingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceUpdateBindingsResponse): RequestSchemaServiceUpdateBindingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.request_schema.v1.RequestSchemaEntitlementBinding request_schema_entitlement_bindings */ 1:
                    message.requestSchemaEntitlementBindings.push(RequestSchemaEntitlementBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceUpdateBindingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.request_schema.v1.RequestSchemaEntitlementBinding request_schema_entitlement_bindings = 1; */
        for (let i = 0; i < message.requestSchemaEntitlementBindings.length; i++)
            RequestSchemaEntitlementBinding.internalBinaryWrite(message.requestSchemaEntitlementBindings[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceUpdateBindingsResponse
 */
export const RequestSchemaServiceUpdateBindingsResponse = new RequestSchemaServiceUpdateBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceFindForAppEntitlementsRequest$Type extends MessageType<RequestSchemaServiceFindForAppEntitlementsRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceFindForAppEntitlementsRequest", [
            { no: 1, name: "entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "25" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceFindForAppEntitlementsRequest>): RequestSchemaServiceFindForAppEntitlementsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entitlementRefs = [];
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceFindForAppEntitlementsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceFindForAppEntitlementsRequest): RequestSchemaServiceFindForAppEntitlementsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementRef entitlement_refs */ 1:
                    message.entitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceFindForAppEntitlementsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 1; */
        for (let i = 0; i < message.entitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.entitlementRefs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindForAppEntitlementsRequest
 */
export const RequestSchemaServiceFindForAppEntitlementsRequest = new RequestSchemaServiceFindForAppEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceFindForAppEntitlementsResponse$Type extends MessageType<RequestSchemaServiceFindForAppEntitlementsResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceFindForAppEntitlementsResponse", [
            { no: 1, name: "request_schemas_entitlement_with_bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestSchemaWithBinding }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceFindForAppEntitlementsResponse>): RequestSchemaServiceFindForAppEntitlementsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestSchemasEntitlementWithBindings = [];
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceFindForAppEntitlementsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceFindForAppEntitlementsResponse): RequestSchemaServiceFindForAppEntitlementsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.request_schema.v1.RequestSchemaWithBinding request_schemas_entitlement_with_bindings */ 1:
                    message.requestSchemasEntitlementWithBindings.push(RequestSchemaWithBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceFindForAppEntitlementsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.request_schema.v1.RequestSchemaWithBinding request_schemas_entitlement_with_bindings = 1; */
        for (let i = 0; i < message.requestSchemasEntitlementWithBindings.length; i++)
            RequestSchemaWithBinding.internalBinaryWrite(message.requestSchemasEntitlementWithBindings[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceFindForAppEntitlementsResponse
 */
export const RequestSchemaServiceFindForAppEntitlementsResponse = new RequestSchemaServiceFindForAppEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceCountBindingsForSchemaRequest$Type extends MessageType<RequestSchemaServiceCountBindingsForSchemaRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceCountBindingsForSchemaRequest", [
            { no: 1, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceCountBindingsForSchemaRequest>): RequestSchemaServiceCountBindingsForSchemaRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestSchemaId = "";
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceCountBindingsForSchemaRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceCountBindingsForSchemaRequest): RequestSchemaServiceCountBindingsForSchemaRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_schema_id */ 1:
                    message.requestSchemaId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceCountBindingsForSchemaRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_schema_id = 1; */
        if (message.requestSchemaId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestSchemaId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceCountBindingsForSchemaRequest
 */
export const RequestSchemaServiceCountBindingsForSchemaRequest = new RequestSchemaServiceCountBindingsForSchemaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceCountBindingsForSchemaResponse$Type extends MessageType<RequestSchemaServiceCountBindingsForSchemaResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceCountBindingsForSchemaResponse", [
            { no: 1, name: "num_bindings", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceCountBindingsForSchemaResponse>): RequestSchemaServiceCountBindingsForSchemaResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.numBindings = 0;
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceCountBindingsForSchemaResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceCountBindingsForSchemaResponse): RequestSchemaServiceCountBindingsForSchemaResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 num_bindings */ 1:
                    message.numBindings = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceCountBindingsForSchemaResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 num_bindings = 1; */
        if (message.numBindings !== 0)
            writer.tag(1, WireType.Varint).int64(message.numBindings);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceCountBindingsForSchemaResponse
 */
export const RequestSchemaServiceCountBindingsForSchemaResponse = new RequestSchemaServiceCountBindingsForSchemaResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceSearchRequest$Type extends MessageType<RequestSchemaServiceSearchRequest> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceSearchRequest>): RequestSchemaServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceSearchRequest): RequestSchemaServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceSearchRequest
 */
export const RequestSchemaServiceSearchRequest = new RequestSchemaServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestSchemaServiceSearchResponse$Type extends MessageType<RequestSchemaServiceSearchResponse> {
    constructor() {
        super("c1.api.request_schema.v1.RequestSchemaServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestSchema },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestSchemaServiceSearchResponse>): RequestSchemaServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestSchemaServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestSchemaServiceSearchResponse): RequestSchemaServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.request_schema.v1.RequestSchema list */ 1:
                    message.list.push(RequestSchema.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestSchemaServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.request_schema.v1.RequestSchema list = 1; */
        for (let i = 0; i < message.list.length; i++)
            RequestSchema.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.request_schema.v1.RequestSchemaServiceSearchResponse
 */
export const RequestSchemaServiceSearchResponse = new RequestSchemaServiceSearchResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.request_schema.v1.RequestSchemaService
 */
export const RequestSchemaService = new ServiceType("c1.api.request_schema.v1.RequestSchemaService", [
    { name: "Create", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/request_schemas", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Request_Schema" }], group: "Request Schema" }] }, "authz.method": { role: "EDITOR" } }, I: RequestSchemaServiceCreateRequest, O: RequestSchemaServiceCreateResponse },
    { name: "Delete", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/request_schemas/{request_schema_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Request_Schema" }], group: "Request Schema" }] }, "authz.method": { role: "EDITOR" } }, I: RequestSchemaServiceDeleteRequest, O: RequestSchemaServiceDeleteResponse },
    { name: "Get", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/request_schemas/{request_schema_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Request_Schema" }], group: "Request Schema" }] }, "authz.method": { role: "VIEWER" } }, I: RequestSchemaServiceGetRequest, O: RequestSchemaServiceGetResponse },
    { name: "FindByAppEntitlement", options: { "authz.method": { role: "VIEWER" } }, I: RequestSchemaServiceFindByAppEntitlementRequest, O: RequestSchemaServiceFindByAppEntitlementResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: RequestSchemaServiceListRequest, O: RequestSchemaServiceListResponse },
    { name: "Update", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/request_schemas/{request_schema.id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Request_Schema" }], group: "Request Schema" }] }, "authz.method": { role: "EDITOR" } }, I: RequestSchemaServiceUpdateRequest, O: RequestSchemaServiceUpdateResponse },
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: RequestSchemaServiceSearchRequest, O: RequestSchemaServiceSearchResponse },
    { name: "CreateEntitlementBindings", options: { "authz.method": { role: "EDITOR" } }, I: RequestSchemaServiceCreateEntitlementBindingsRequest, O: RequestSchemaServiceCreateEntitlementBindingsResponse },
    { name: "RemoveEntitlementBindings", options: { "authz.method": { role: "EDITOR" } }, I: RequestSchemaServiceRemoveEntitlementBindingsRequest, O: RequestSchemaServiceRemoveEntitlementBindingsResponse },
    { name: "CreateEntitlementBinding", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/request_schema_entitlement_binding", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Request Schema Entitlement Binding" }], group: "Request Schema Entitlement Binding" }] }, "authz.method": { role: "EDITOR" } }, I: RequestSchemaServiceCreateEntitlementBindingRequest, O: RequestSchemaServiceCreateEntitlementBindingResponse },
    { name: "RemoveEntitlementBinding", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/request_schema_entitlement_binding", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Request Schema Entitlement Binding" }], group: "Request Schema Entitlement Binding" }] }, "authz.method": { role: "EDITOR" } }, I: RequestSchemaServiceRemoveEntitlementBindingRequest, O: RequestSchemaServiceRemoveEntitlementBindingResponse },
    { name: "FindBindingForAppEntitlement", options: { "apigw.v1.method": { operations: [{ method: "PUT", route: "/api/v1/request_schema_entitlement_binding", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Request Schema Entitlement Binding" }], group: "Request Schema Entitlement Binding" }] }, "authz.method": { role: "EDITOR" } }, I: RequestSchemaServiceFindBindingForAppEntitlementRequest, O: RequestSchemaServiceFindBindingForAppEntitlementResponse },
    { name: "UpdateBindings", options: { "authz.method": { role: "EDITOR" } }, I: RequestSchemaServiceUpdateBindingsRequest, O: RequestSchemaServiceUpdateBindingsResponse },
    { name: "FindForAppEntitlements", options: { "authz.method": { role: "VIEWER" } }, I: RequestSchemaServiceFindForAppEntitlementsRequest, O: RequestSchemaServiceFindForAppEntitlementsResponse },
    { name: "CountBindingsForSchema", options: { "authz.method": { role: "VIEWER" } }, I: RequestSchemaServiceCountBindingsForSchemaRequest, O: RequestSchemaServiceCountBindingsForSchemaResponse }
]);
